export const SMART_DEFAULTS_STORAGE_KEY = 'sv_product_smart_defaults';

export const PRODUCTS_SMART_DEFAULTS_PATH = '/settings/products';

export const OPEN_EDIT_DEFAULTS_PARAM = 'editDefaults';

export const getProductsEditDefaultsUrl = () =>
    `${PRODUCTS_SMART_DEFAULTS_PATH}?${OPEN_EDIT_DEFAULTS_PARAM}=1`;

export const DEFAULT_SMART_DEFAULTS = {
    cogsPercentOfPrice: 30,
    replenishmentDays: 15,
    unsellableReturnsPercent: 50,
    taxPaidOnCogsPercent: 18,
    taxCollectedOnSalesPercent: 18,
};

let cachedDefaults = null;

export const persistSmartDefaults = (defaults) => {
    try {
        localStorage.setItem(SMART_DEFAULTS_STORAGE_KEY, JSON.stringify(defaults));
    } catch (_) {
        // ignore quota errors
    }
};

export const setSmartDefaultsCache = (defaults) => {
    cachedDefaults = { ...defaults };
    persistSmartDefaults(cachedDefaults);
};

export const readSmartDefaults = () => {
    if (cachedDefaults) {
        return { ...cachedDefaults };
    }

    try {
        const stored = localStorage.getItem(SMART_DEFAULTS_STORAGE_KEY);
        if (stored) {
            return { ...DEFAULT_SMART_DEFAULTS, ...JSON.parse(stored) };
        }
    } catch (_) {
        // ignore malformed localStorage
    }

    return { ...DEFAULT_SMART_DEFAULTS };
};

export const getSmartDefaults = () => readSmartDefaults();

export const getEstimatedBadgeForPlRow = (rowKey, defaults = getSmartDefaults()) => {
    switch (rowKey) {
        case 'cost_of_goods':
            return { variant: 'default', value: `${defaults.cogsPercentOfPrice}%` };
        case 'refund_cost':
            return { variant: 'default', value: `${defaults.unsellableReturnsPercent}%` };
        case 'net_tax':
            return { variant: 'default', value: `${defaults.taxCollectedOnSalesPercent}%` };
        default:
            return null;
    }
};
